import React from 'react'
import './header.css'
import ME from '../../assets/MEv03.png'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'

const header = () => {
  return (
    <header>
      <div className="container header_container">
        <h1>Thomas Naschenweng</h1>
        <h5 className="text-light">Fullstack Developer</h5>
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="me" />
        </div>
        
        <CTA />

        <a href="#contact" className='scroll_down'>Scroll Down</a>
        </div>
    </header>
  )
}

export default header